<template>
  <div>
    <div class="box-save-minus">
      <div class="typeface-size" :style="{ fontSize: fontSize + 'px' }">
        第 {{ TextareaNum }} 题 (主观题)
      </div>
      <div class="font-size-save-minus">
        <el-button size="small" @click="increaseFontSize">+</el-button>
        <span>{{ text }}</span>
        <el-button size="small" @click="decreaseFontSize">-</el-button>
      </div>
    </div>
    <!-- <div class="name">第 {{ TextareaNum }} 题 (主观题)</div> -->
    <div class="name" :style="{ fontSize: fontSize + 'px' }">{{ TextareaContent }}:</div>
    <div class="answer">
      <el-input
        :style="radioLabelStyle"
        type="textarea"
        v-model="answer"
        @input="handler"
        :autosize="{ minRows: 5, maxRows: 10 }"
      ></el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    TextareaNum: {
      type: Number,
      require: true,
      default: 0,
    },
    TextareaContent: {
      type: String,
      require: true,
    },
    dataId: {
      type: String | Number,
      require: true,
    },
    currentAnswer: {
      type: String,
    },
  },
  data() {
    return {
      answer: null,
      text: "字号",
      fontSize: 16, // 初始字体大小
    };
  },
  watch: {
    currentAnswer: {
      handler(val) {
        if (!val) return;
        this.answer = val;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    radioLabelStyle() {
      return { fontSize: this.fontSize + "px" };
    },
  },
  methods: {
    onSubmit() {
      return { No: this.TextareaNum, answer: this.answer, dataId: this.dataId };
    },
    handler(e) {
      this.$emit("change", { No: this.TextareaNum, answer: e, dataId: this.dataId });
    },
    increaseFontSize() {
      if (this.fontSize == 28) {
        this.$message({
          message: "已达到最大值",
          type: "warning",
        });
      } else {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize == 10) {
        this.$message({
          message: "已达到最小值",
          type: "warning",
        });
      } else {
        this.fontSize -= 2;
      }
    },
  },
};
</script>
<style scoped>
.answer {
  width: 100%;
}

.el-textarea >>> .el-textarea__inner {
  width: 100%;
  border: 2px solid rgb(64, 112, 179);
  padding: 26px 30px;
  resize: vertical;
  /* font-size: 24px; */
  font-size: inherit;
}
.name {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 30px;
}
.box-save-minus {
  height: 50px;
}
.typeface-size {
  float: left;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
}
.font-size-save-minus {
  font-family: 思源黑体;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/topicTextarea.vue